import { Box } from '@mui/material';

interface PaddedPaneProps {
  children: React.ReactNode;
  borderless?: boolean;
  hasTopMargin?: boolean;
  tinted?: boolean;
  flexible?: boolean;
}

const PaddedPane = ({
  children,
  borderless,
  hasTopMargin,
  tinted,
  flexible,
}: PaddedPaneProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        padding: 2,
        marginTop: hasTopMargin ? 2 : 0,
        borderRadius: '8px',
        border: borderless ? 'none' : '1px solid #DCE4E8',
        flex: 1,
        minHeight: 0,
        width: '100%',
        boxSizing: 'border-box',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        '& .MuiTypography-root': {
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        },
        ...(tinted && {
          borderRadius: 1.5,
          border: '1px solid #D2DAE3',
          backgroundColor: '#DCE4E8',
        }),
        ...(flexible && {
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }),
      }}
    >
      {children}
    </Box>
  );
};

export default PaddedPane;
